<template>
  <div class="select-wrapper flex flex-col text-left">
    <label :for="id">{{ label }}</label>
    <select class="default-select full bordered" :id="id" v-model="localValue">
      <option value="">Select Option</option>
      <option
        v-for="option in data.options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localValue: null
    };
  },
  watch: {
    localValue(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.localValue = val || "";
    }
  },
  mounted() {
    this.localValue = this.value || "";
  }
};
</script>
<style lang="scss" scope>
.select-wrapper {
  width: 100%;
  select {
    width: 100%;
  }
}
</style>
